import { render, staticRenderFns } from "./EsriLegend.vue?vue&type=template&id=401633cc&scoped=true&"
import script from "./EsriLegend.vue?vue&type=script&lang=ts&"
export * from "./EsriLegend.vue?vue&type=script&lang=ts&"
import style0 from "./EsriLegend.vue?vue&type=style&index=0&lang=css&"
import style1 from "./EsriLegend.vue?vue&type=style&index=1&id=401633cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401633cc",
  null
  
)

export default component.exports
import {QBtn} from 'quasar'
component.options.components = Object.assign({QBtn}, component.options.components || {})
